var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseModal',{ref:"modal",attrs:{"size":"xl"},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('DocumentPdf',{attrs:{"pdfUrl":_vm.pdfUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }